export default __webpack_public_path__ + "static/media/buttonhole.18c72bcf.jpg";